import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { SubsidyTable } from './components/SubsidyTable';
import { FaqSection } from './components/FaqSection';
import { ContactSection } from './components/ContactSection';
import { FloatingCta } from './components/FloatingCta';
import { Navigation } from '../../components/feature/Navigation';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* ナビゲーション */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/6981d9e168ff03567ccd394c0c206ad8.jpg" 
                alt="北陸クリーンエネルギー" 
                className="h-12 w-auto"
              />
              <div className={`transition-colors duration-300 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                <div className="font-bold text-lg leading-tight">北陸クリーンエネルギー</div>
                <div className="text-xs opacity-70">Hokuriku Clean Energy</div>
              </div>
            </Link>
            <div className="flex items-center space-x-4">
              <Navigation />
            </div>
          </div>
        </div>
      </nav>

      {/* ヒーローセクション */}
      <HeroSection />

      {/* 太陽光発電のメリット */}
      <BenefitsSection />

      {/* 補助金早見表 */}
      <SubsidyTable />

      {/* FAQ */}
      <FaqSection />

      {/* お問い合わせ */}
      <ContactSection />

      {/* フローティングCTA */}
      <FloatingCta />

      {/* フッター */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20clean%20energy%20company%20logo%20design%20with%20solar%20panel%20and%20sun%20symbol%20in%20emerald%20green%20and%20gold%20colors%2C%20modern%20minimalist%20style%2C%20circular%20badge%20shape%2C%20representing%20renewable%20energy%20and%20sustainability%20for%20Hokuriku%20Clean%20Energy%20company%2C%20simple%20white%20background%2C%20high%20quality%20vector%20style%20illustration&width=200&height=200&seq=logo-hokuriku-clean-energy-001&orientation=squarish" 
                alt="北陸クリーンエネルギー" 
                className="h-10 w-auto"
              />
              <div>
                <div className="font-bold text-base">北陸クリーンエネルギー</div>
                <div className="text-xs opacity-70">Hokuriku Clean Energy</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              〒920-8204 石川県金沢市戸水1-59<br />
              TEL: 076-255-3483 FAX:076-213-5548
            </p>
            <div className="text-xs text-gray-500">
              © 2025 北陸クリーンエネルギー All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors">Website Builder</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
